/**
 * X animations
 */
document.querySelectorAll('.wp-block-acf-x svg').forEach(x => {
  morph_on_scroll(x);
});
